'use client'

import { Button, PlusIcon } from '@chain-zen/ui'
import { useState } from 'react'

import { EnableELDAppsModal } from './enable-eld-apps-modal'

interface IEnableELDAppsButtonProps {
  onAppsChanged?: () => void
}

/**
 * Button that opens the modal for enabling additional ELD apps.
 */
export const EnableELDAppsButton = ({ onAppsChanged }: IEnableELDAppsButtonProps) => {
  const [showEnableModal, setShowEnableModal] = useState(false)

  return (
    <>
      <Button
        onClick={() => setShowEnableModal(true)}
        variant="outline"
        className="w-full py-2.5 px-3 border-dashed border-border hover:border-zinc-300 dark:hover:border-zinc-600 hover:bg-accent/30 text-muted-foreground hover:text-foreground"
      >
        <PlusIcon className="w-4 h-4" />
        <span className="text-sm">Enable more ELD apps</span>
      </Button>
      <EnableELDAppsModal
        isOpen={showEnableModal}
        onAppsChanged={onAppsChanged}
        onClose={() => setShowEnableModal(false)}
      />
    </>
  )
}
